import MainLayout from '@/common/components/layouts/MainLayout';
import { PropsWithChildren } from 'react';

export default ({ children }: PropsWithChildren) => {
  return (
    <MainLayout title="زیان‌دیده / حساب بانکی" header="titleHeader">
      {children}
    </MainLayout>
  );
};
